// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3u0k3","inner":"Footer_inner__kwJ2S"};